/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useGridApiRef, GridActionsCellItem } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import AskDialog from '../../../components/common/dialog/AskDialog';
import * as employeeApi from '../../../lib/api/employee';

import EtcList from '../../../components/employeemng/personal/EtcList';
import { listEtc, unloadEtc } from '../../../modules/empModule/empPersonal';




const EtcListContainer = ({ employee }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { etcs, error, loading } = useSelector(
    ({ empModule, loading }) => ({
      etcs: empModule.employeePersonal.etcs,
      error: empModule.employeePersonal.etcsError,
      loading: loading['employee/LIST_ETC'],
    }),
  );

  useEffect(() => {
    if (employee) {
      dispatch(listEtc({ id: employee.usrUuid, infoTyp: 'ETC' }));
    }

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadEtc());
    };
  }, []);

  const apiRef = useGridApiRef();

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleCellFocusOut = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleEditClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.startRowEditMode(id, 'edit');
  };

  const handleSaveClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.commitRowChange(id);
    apiRef.current.startRowEditMode(id, 'view');

    const row = apiRef.current.getRow(id);

    onSave(employee.usrUuid, row);
  };

  const onSave = async (id, row) => {
    try {
      const response = await employeeApi.editResumeByEmp(row);

      if (response.data.result === 'success') {
        console.log(row);
        apiRef.current.updateRows([{ ...row, isNew: false }]);
        enqueueSnackbar('수정 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      apiRef.current.updateRows([{ ...row, isNew: false }]);
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const handleCancelClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.startRowEditMode(id, 'view');

    const row = apiRef.current.getRow(id);
    if (row.isNew) {
      apiRef.current.updateRows([{ id, _action: 'delete' }]);
    }
  };

  const [removeId, setRemoveId] = useState(null);
  const handleDeleteClick = (id) => (event) => {
    event.stopPropagation();

    //remove 작업
    setVisible(true);
    setRemoveId(id);
  };

  const onRemove = async () => {
    try {
      const res = await employeeApi.removeResumeByEmp(removeId);
      if (res) {
        apiRef.current.updateRows([{ id: removeId, _action: 'delete' }]);
        enqueueSnackbar('삭제 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setRemoveId(null);
  };

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'infoUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'usrUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'infoTyp',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'attrVal1',
        headerName: '기타사항명',
        minWidth: 100,
        flex: 1,
        type: 'string',
        editable: true,
      },
      {
        field: 'attrVal2',
        headerName: '기타사항데이터',
        minWidth: 100,
        flex: 1,
        type: 'string',
        editable: true,
      },
      {
        field: 'attrVal3',
        headerName: '기타사항 설명',
        minWidth: 100,
        flex: 1,
        type: 'string',
        editable: true,
      },
      {
        field: 'cngNm',
        headerName: '수정자',
        minWidth: 80,
        flex: 0.3,
        type: 'string',
        editable: false,
      },
      {
        field: 'cngDt',
        headerName: '수정일',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Actions',
        width: 100,
        cellClassName: 'actions',
        getActions: ({ id }) => {
          const isInEditMode = apiRef.current.getRowMode(id) === 'edit';

          if (isInEditMode) {
            return [
              <GridActionsCellItem
                icon={<SaveIcon />}
                label="Save"
                onClick={handleSaveClick(id)}
                color="primary"
              />,
              <GridActionsCellItem
                icon={<CancelIcon />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(id)}
                color="inherit"
              />,
            ];
          }

          return [
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit"
              className="textPrimary"
              onClick={handleEditClick(id)}
              color="inherit"
            />,
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={handleDeleteClick(id)}
              color="inherit"
            />,
          ];
        },
      },
    ],
    [apiRef, handleEditClick, handleSaveClick, handleCancelClick],
  );

  const [visible, setVisible] = useState(false);

  const onCancle = () => {
    setVisible(false);
    setRemoveId(null);
  };

  const onConfirm = () => {
    setVisible(false);
    onRemove();
  };

  return (
    <>
      <EtcList
        apiRef={apiRef}
        columns={columns}
        rows={etcs}
        error={error}
        loading={loading}
        handleRowEditStart={handleRowEditStart}
        handleRowEditStop={handleRowEditStop}
        handleCellFocusOut={handleCellFocusOut}
        
        columnVisibilityModel={{
          id: false,
          infoUuid: false,
          usrUuid: false,
          infoTyp: false,
        }}
      />
      <AskDialog
        visible={visible}
        title="기타사항 삭제"
        description="선택한 기타사항을 삭제하시겠습니까?"
        confirmText="삭제"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </>
  );
};

export default EtcListContainer;
